exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".troubles.inner-block .areas,.troubles.inner-block .general{margin-bottom:35px}.troubles.inner-block .areas .zones{padding-left:15px;padding-right:15px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/panel/troubles.component/styles.less
 ** module id = 621
 ** module chunks = 0
 **/